module.exports = __webpack_public_path__ + "img/alimenticioImage.3488d30e.svg";